import { z } from "zod";

/** The temporary account types of ADR 0007, as Keycloak realm roles. */
export const AccountType = z.enum(["tenant-admin", "admin", "user"]);
export type AccountType = z.infer<typeof AccountType>;

/** The one account type among realm roles; none or several read as "user" (fails closed). */
export function parseAccountType(roles: unknown): AccountType {
  const held = Array.isArray(roles) ? AccountType.options.filter((t) => roles.includes(t)) : [];
  return held.length === 1 ? (held[0] as AccountType) : "user";
}

export const Identity = z.object({
  sub: z.string().min(1),
  name: z.string().optional(),
  email: z.string().optional(),
  organizations: z.array(z.string()),
  accountType: AccountType.default("user"),
});
export type Identity = z.infer<typeof Identity>;

/** Organization aliases from Keycloak's claim: a list of aliases or an object keyed by alias. */
export function parseOrganizations(claim: unknown): string[] {
  if (Array.isArray(claim)) return claim.filter((a): a is string => typeof a === "string");
  if (claim && typeof claim === "object") return Object.keys(claim);
  return [];
}
